import { render, staticRenderFns } from "./updateReglementModal.vue?vue&type=template&id=82505b22&"
import script from "./updateReglementModal.vue?vue&type=script&lang=js&"
export * from "./updateReglementModal.vue?vue&type=script&lang=js&"
import style0 from "./updateReglementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports